import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[lettersAndNumbersOnly]'
})
export class LettersAndNumbersOnlyDirective {

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const keyCode = event.keyCode;
    const isLetterOrNumber = (keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 96 && keyCode <= 105) || keyCode == 46 || keyCode == 8;

    if (!isLetterOrNumber) {
      event.preventDefault();
    }    
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    const isLetterOrNumber = /^[0-9a-zA-Z]+$/.test(pastedText);

    if (!isLetterOrNumber) {
      event.preventDefault();
    }
  }

}
